import React, { useState } from 'react';
import classNames from 'classnames';
import { ExternalLink, Modal, MailerliteSubscribeForm } from '../../../../components';
import { whatsappIcon, instagramIcon } from '../../Primitives/Link/Icons';

const WhatsAppIcon = () => whatsappIcon();
const InstagramIcon = () => instagramIcon();
const EmailIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.89 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
  </svg>
);

/**
 * Stay Updated section component for footer
 * 
 * @component
 * @param {Object} props
 * @param {string?} props.className
 * @param {string?} props.whatsappUrl URL for WhatsApp status
 * @param {string?} props.instagramUrl URL for Instagram
 * @param {string?} props.emailUrl URL for email subscription
 * @returns {JSX.Element}
 */
const StayUpdatedSection = props => {
  const { className, whatsappUrl, instagramUrl, emailUrl } = props;
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);

  const rootClasses = classNames(
    "mx-0 p-4 max-w-[var(--contentMaxWidthPages)] bg-gray-50 rounded-xl border-gray-200 mx-auto flex flex-col md:items-center",
    className
  );

  const handleEmailClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    // Always show the MailerLite form modal instead of using emailUrl
    // This prioritizes the subscription form over mailto links
    setIsEmailModalOpen(true);
  };

  return (
    <div className={rootClasses}>
      <h3 className="text-left px-4 py-0 my-0 pb-1 pt-0 text-xl md:text-2xl font-normal leading-8 md:leading-9 text-gray-900 mb-1">
        Stay updated with new arrivals.
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-3 max-w-4xl border border-gray-200 bg-white">

        {/* Instagram */}
        <div className="relative flex mb-1 items-center text-center p-4 border-r-1 border-gray-200 cursor-pointer transition-all duration-200 hover:-translate-y-0.5 hover:shadow-lg">
          <InstagramIcon />
          <div className="flex-grow ml-4 text-left">
            <div className="text-md font-normal leading-6 text-gray-900">Follow Us on</div>
            <div className="text-md font-bold leading-6 text-gray-900">Instagram</div>
          </div>
          {instagramUrl && (
            <ExternalLink
              href={instagramUrl}
              className="absolute inset-0 opacity-0 z-10"
              aria-label="Follow on Instagram"
            />
          )}
        </div>

        {/* WhatsApp Status */}
        <div className="relative flex items-center text-center p-4  border-r-1 border-gray-200 cursor-pointer transition-all duration-200 hover:-translate-y-0.5 hover:shadow-lg">
          <div className="flex items-center justify-center mb-1">
            <WhatsAppIcon />
          </div>
          <div className="flex-grow ml-4 text-left">
            <div className="text-md font-normal leading-6 text-gray-900">Follow Our</div>
            <div className="text-md font-bold leading-6 text-gray-900">Whatsapp Status</div>
          </div>
          {whatsappUrl && (
            <ExternalLink
              href={whatsappUrl}
              className="absolute inset-0 opacity-0 z-10"
              aria-label="Follow WhatsApp status"
            />
          )}
        </div>

        {/* Email Subscription */}
        <div 
          className="relative flex items-center text-center p-4 cursor-pointer transition-all duration-200 hover:-translate-y-0.5 hover:shadow-lg"
          onClick={handleEmailClick}
        >
          <div className="w-14 h-14 flex items-center justify-center rounded-full bg-gray-900 text-white">
            <EmailIcon />
          </div>
          <div className="flex-grow ml-4 text-left">
            <div className="text-md font-normal leading-6 text-gray-900">Subscribe to Email</div>
            <div className="text-md font-bold leading-6 text-gray-900">Updates</div>
          </div>
        </div>
      </div>

      {/* Email Subscription Modal */}
      <Modal
        id="EmailSubscriptionModal"
        isOpen={isEmailModalOpen}
        onClose={() => setIsEmailModalOpen(false)}
        onManageDisableScrolling={() => {}}
      >
        <div className="p-6 max-w-md mx-auto">
          <MailerliteSubscribeForm 
            title="Stay Updated"
            description="Subscribe to get the latest updates and new arrivals."
          />
        </div>
      </Modal>
    </div>
  );
};

export default StayUpdatedSection; 